module.exports = __webpack_public_path__ + "static/media/builtinModem.79f4d4d0.png";